import React, { useEffect, useState } from "react";
import { Table, Button, Tooltip, Popconfirm, Select } from "antd";
import {
  CheckCircleOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import { formatDate } from "../../../utils/dateFormatter";

const CompanyOfficeStaffList = () => {
  const navigate = useNavigate();

  const [staffData, setStaffData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);
const [selectedRole, setSelectedRole] = useState("");

const GET_ROLES_API = () => {

  const FORM_DATA = new FormData();

  post(ApiURL.list_office_roles, FORM_DATA).then((res) => {

    if(res?.status){
      setRoles(res?.roles || []);
    }else{
      ErrorToast("Error", res?.message);
    }

  });

};


  const OFFICE_STAFF_LIST_API = (role = "") => {

  setLoading(true);

  const FORM_DATA = new FormData();

  if(role){
    FORM_DATA.append("filter", role);
  }

  post(ApiURL.list_office_staff, FORM_DATA)
    .then((res) => {
      if (res?.status) {
        setStaffData(res?.staff || []);
      } else {
        ErrorToast("Error", res?.message);
      }
    })
    .finally(() => {
      setLoading(false);
    });

};

  useEffect(() => {
     GET_ROLES_API();
    OFFICE_STAFF_LIST_API();
  }, []);


  const columns = [
    {
      title: "ID",
      dataIndex: "staff_id",
      align: "center",
      key: "staff_id",
    },
    {
      title: "Name",
      dataIndex: "name",
      align: "center",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      align: "center",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phone_number",
      align: "center",
      key: "phone_number",
    },
    {
      title: "Role",
      dataIndex: "role",
      align: "center",
      key: "role",
    },
    {
  title: "Ships",
  dataIndex: "ship_details",
  align: "center",
  key: "ship_details",
  render: (ships) => {
    if (!ships || ships.length === 0) return "-";

    return ships.map((ship) => ship.name).join(", ");
  },
},
    {
      title: "Created At",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: (text) => formatDate(text),
    },
    {
      title: "Status",
      dataIndex: "staff_status",
      align: "center",
      key: "staff_status",
      render: (status) =>
        status ? (
          <span className="table-status-activate">Active</span>
        ) : (
          <span className="table-status-deactivate">Inactive</span>
        ),
    },
    {
      title: "Action",
      align: "center",
      key: "action",
      render: (_, record) => (
        <>
          <Tooltip title="Edit Staff">
            <Button
              type="primary"
              size="small"
              icon={<EditOutlined />}
              style={{ marginRight: 10 }}
              onClick={() =>
                navigate(`/edit-company-staff/${btoa(record.staff_id)}`)
              }
            />
          </Tooltip>

          <Popconfirm
            title="Delete Staff"
            description={`Are you sure you want to delete ${record.name}?`}
            onConfirm={() => DELETE_OFFICE_STAFF(record.staff_id)}
          >
            <Tooltip title="Delete Staff">
              <Button type="primary" size="small" icon={<DeleteOutlined />} />
            </Tooltip>
          </Popconfirm>
        </>
      ),
    },
  ];

  const DELETE_OFFICE_STAFF = (staff_id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("staff_id", staff_id);

    post(ApiURL.delete_office_staff, FORM_DATA).then((res) => {
      if (res?.status) {
        SuccessToast("Success", "Staff deleted successfully");
        OFFICE_STAFF_LIST_API();
      } else {
        ErrorToast("Error", "Failed to delete staff");
      }
    }); 
  };

  return (
    <>
      <div>
        <div className="row">
          <div className="col-3">
            <label className="block-label">Select Role</label>
            <Select
              placeholder="---- Select Role ----"
              style={{ width: "100%" }}
              value={selectedRole}
              onChange={(value) => {
                setSelectedRole(value);
                OFFICE_STAFF_LIST_API(value);
              }}
              allowClear
              onClear={() => {
                setSelectedRole("");
                OFFICE_STAFF_LIST_API();
              }}
            >
              {roles.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </div>
        </div>
        <div className="row" style={{ padding: "10px" }}>
          <div className="col-4" style={{ marginLeft: "5px", alignSelf: "end" }}>
            <div className="theme-content-title text-left">
              <h3>Company Office Staff</h3>
            </div>
          </div>
          <div className="col-2"></div>
          <div className="col-6" style={{ display: "flex", justifyContent: "flex-end" }}>
            <div className="d-flex align-items-center">
              <Button
                type="primary"
                className="save_btn"
                onClick={() => navigate("/company-office-staff-add")}
              >
                Add Office Staff
              </Button>
            </div>
          </div>
        </div>
        <Table
          bordered
          columns={columns}
          dataSource={staffData}
          loading={loading}
          rowKey="staff_id"
          pagination={{ pageSize: 10 }}
          className="custom-table"
        />
      </div>
    </>
  );
};

export default CompanyOfficeStaffList;